import React from "react";
import { Table, Input, Button, Space, Modal } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import QuickView from "./QuickView";
import Printvoucher from "./Printvoucher";
import moment from "moment";

class Rendertable extends React.Component {
  state = {
    selectedRowKeys: [],
    showModal: false,
    selectedDraft: null,
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  onSelectChange = (selectedRowKeys) => {
    // console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  handleViewDetails = (draft) => {
    this.setState({
      showModal: true,
      selectedDraft: draft,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedDraft: null,
    });
  };

  render() {
    const { selectedRowKeys, showModal, selectedDraft } = this.state;

    const columns = [
      {
        title: "SL",
        key: "index",
        render: (value, item, index) => {
          return index + 1;
        },
      },
      {
        title: "Voucher number",
        dataIndex: "challan_number",
        key: "challan_number",
        ...this.getColumnSearchProps("challan_number"),
      },
      {
        title: "List Quantity",
        dataIndex: "list_quantity",
        key: "list_quantity",
      },
      {
        title: "Issue Date",
        dataIndex: "issue_date",
        key: "issue_date",            
          render: (value) => {
            return moment(value).format("DD-MM-YYYY");
          },           
      },
      {
        title: "Quick Table View",
        dataIndex: "",
        key: "x",
        render: (text, record) => {
          return <Printvoucher 
          data={record.data} 
          challanNumber={record.challan_number}
          listQuantity={record.list_quantity}
          issueDate={record.issue_date}  
          comments={record.comments}
          />;
        },
      },
    ];
    return (
    <>
      <Table
        columns={columns}
        dataSource={this.props.List}        
        rowKey="id"
        pagination={{
          defaultPageSize: 10,
        }}
      />
    </>
    );
  }
}

export default Rendertable;


